import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export const PasswordForm = () => {
  const [f, setF] = useState({ current_password: "", new_password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/password", f);
      toast.success("Password updated");
      setF({ current_password: "", new_password: "" });
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={submit} className="panel p-6" data-testid="admin-password-form">
      <h2 className="red-title mb-4 text-xl">Change Admin Password</h2>
      <div className="grid gap-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
        <div><label className="label">Current password</label><input className="field" type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="admin-password-current-input" /></div>
        <div><label className="label">New password (8+ chars)</label><input className="field" type="password" required minLength={8} value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="admin-password-new-input" /></div>
        <button className="btn-ghost !py-2.5 !text-base" data-testid="admin-password-submit-button">Update</button>
      </div>
    </form>
  );
};
